
import Vue from "vue";
import {IModal, ModalType} from "@/services/modal-service";
import AppModalItemIframe from "./ModalItemIframe.vue";
import AppModalItemContactEdit from "./ModalItemContactEdit.vue";
import AppModalItemProductEdit from "./ModalItemProductEdit.vue";

export default Vue.extend({
	props: {
		modal: {
			type: Object as ()=>IModal,
			required: true
		}
	},
	computed: {
		isIframe():boolean{
			return this.modal.type == ModalType.IFRAME;
		},
		isContactEdit():boolean {
			return this.modal.type == ModalType.CONTACT_EDIT;
		},
		isProductEdit():boolean {
			return this.modal.type == ModalType.PRODUCT_EDIT;
		}
	},
	methods: {
		close(){
			this.$emit("close");
		}
	},
	components: {
		AppModalItemIframe,
		AppModalItemContactEdit,
		AppModalItemProductEdit
	}
});
